var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplay)?_c('a',{staticClass:"ml-auto",attrs:{"href":_vm.imageLink}},[_c('img',{staticClass:"column is-header-ad is-hidden-mobile px-4",attrs:{"src":_vm.imageSrc,"alt":"advertisement"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }